export default __webpack_public_path__ + "static/media/sidebar6.43ea0184.jpg";